import {addClickHandler} from "@/layouts/documentClickHandler.js";
import {domLoader} from "@/loader.js";
import {getTheme, syncThemeIcons, toggleTheme} from "@/layouts/theme-transition.js";

window.themeSwitchLoaded = false
domLoader(function () {
  if (window.themeSwitchLoaded) return
  window.themeSwitchLoaded = true

  syncThemeIcons(getTheme());

  addClickHandler(".hbtn--theme, #theme-switch", function (event) {
    const originEl = event.target?.closest('#theme-switch') || document.getElementById('theme-switch');
    toggleTheme(event, originEl);
  });
});
